import React from 'react';
import ModalSkeleton from '../ModalSkeleton';
import classes from './ChangePasswordModal.module.css';
import Input from '../../Component/Input/Input';
import { useState } from 'react';
import Button from '../../Component/Button/Button';
import { useUpdatePasswordMutation } from '../../store/apiSlice/apiSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveLoginUserData } from '../../store/auth/authSlice';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const ChangePasswordModal = ({ show, setShow }) => {
  const { t: d } = useTranslation(['webCommon', 'dashboardCompanyProfile']);
  const { t: toastM } = useTranslation('dashboardCompanyProfile');
  const ttm = (key) => toastM(`modalToast.${key}`); // ttm = translation toast message
  const t = (key) => d(`updatePasswordModal.${key}`);
  const { user } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [updatePassword, { isLoading }] = useUpdatePasswordMutation();

  const handleLogin = async () => {
    const params = {
      // email,
      // password,
      passwordCurrent: currentPassword,
      password: newPassword,
      confirmPassword
    };
    for (let key in params) {
      if (!params[key]) {
        return toast.error(`${ttm('mt1')}`);
      }
    }

    if (params?.passwordCurrent?.length < 8) {
      return toast.error(`${ttm('mt2')}`);
    }
    if (params?.password?.length < 8) {
      return toast.error(`${ttm('mt2')}`);
    }
    if (params?.passwordCurrent == params?.password) {
      return toast.error(`${ttm('mt3')}`);
    }
    if (params?.password !== params.confirmPassword) {
      return toast.error(`${ttm('mt4')}`);
    }

    const response = await updatePassword(params);
    if (response?.data) {
      toast.success(`${ttm('mt5')}`);
      dispatch(saveLoginUserData(response?.data));
      navigate(
        `/${
          ['company', 'agent'].includes(user?.role) ? `${user?.role}/dashboard` : 'account-settings'
        }`
      );
    }
  };
  return (
    <ModalSkeleton show={show} setShow={setShow} header={t('title')} headerClass={classes.header}>
      <div className={classes.inputs}>
        <Input
          value={currentPassword}
          setValue={setCurrentPassword}
          inputStyle={{
            borderRadius: '5px'
          }}
          placeholder={t('currentPassword')}
          type={'password'}
          autoComplete="new-password"
        />
        <Input
          value={newPassword}
          setValue={setNewPassword}
          inputStyle={{
            borderRadius: '5px'
          }}
          placeholder={t('newPassword')}
          type={'password'}
          autoComplete="new-password"
        />
        <Input
          value={confirmPassword}
          setValue={setConfirmPassword}
          inputStyle={{
            borderRadius: '5px'
          }}
          placeholder={t('confirmPassword')}
          type={'password'}
          autoComplete="new-password"
        />
      </div>

      <Button
        className={classes.btn}
        label={isLoading ? t('submitBtnLoading') : t('submitBtn')}
        onClick={handleLogin}
        variant="primary"
      />
    </ModalSkeleton>
  );
};

export default ChangePasswordModal;
